import HistoryIcon from "@mui/icons-material/History";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useMemo } from "react";
import { useNavigate } from "react-router";
import {
    tsToDateFormatter,
    tsToDateTimeFormatter
} from "../../../../Common/EndPoints";
import DataTable from "../../../DataGrid/DataGrid";

const MaintenanceDataTable = ({ loader, rowsData, paginantion, setPaginantion, filters }) => {
    const navigate = useNavigate();
    const assetMaintenaceColumns = useMemo(() => {
        return [
            {
                field: "editActions",
                type: "actions",
                minWidth: 80,
                flex: 1,
                hideable: false,
                getActions: (params) => [
                    <Tooltip placement="bottom" title="Asset maintenance history" disableInteractive>
                        <GridActionsCellItem
                            icon={<HistoryIcon />}
                            label="Aseet maintenance history"
                            onClick={(event) => {
                                let navigationState = {
                                    asset: {
                                        assetName: params.row.gearName,
                                        assetId: params.row.assetId,
                                    },
                                    tsFilters: {
                                        startTs: filters?.startTs ?? null,
                                        endTs: filters?.endTs ?? null,
                                    },
                                    scheduleCode: params.row.scheduleCode,
                                };

                                navigate("/maintenanace-history", { state: navigationState });
                            }}
                        />
                    </Tooltip>,
                ],
            },
            {
                field: "zone",
                headerName: "Zone",
                sortable: true,
                // minWidth: 70,
                hideable: true,
            },
            {
                field: "div",
                headerName: "Division",
                sortable: true,
                minWidth: 80,
                hideable: true,
            },
            {
                field: "gearName",
                headerName: "Asset Name",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
            },
            {
                field: "scheduleCode",
                headerName: "Schedule Code",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
            },
            {
                field: "maintenanceCategory",
                headerName: "Maintenance Category",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
            },
            {
                field: "system",
                headerName: "System",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
            },
            {
                field: "periodicity",
                headerName: "Periodicity",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
            },
            {
                field: "status",
                headerName: "Schedule Status",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
            },
            {
                field: "expectedDt",
                headerName: "Next Due Date",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
                ...tsToDateFormatter,
            },
            {
                field: "completedDt",
                headerName: "Last Done Date",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
                ...tsToDateTimeFormatter,
            },
            {
                field: "completedByName",
                headerName: "Last Done By",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
            },
            {
                field: "designation",
                headerName: "Designation",
                sortable: true,
                minWidth: 110,
                hideable: true,
                flex: 1,
            },
        ];
    }, []);
    return (
        <div className="maintenanceTabTable">
            <DataTable
                tableInfo={{
                    id: `devices-table`,
                    label: `Devices`,
                    requireAuthSign: false,
                    timestamp: { startTs: null, endTs: null },
                }}
                loading={loader}
                rows={rowsData}
                columns={assetMaintenaceColumns}
                paginationMode={"server"}
                // rowCount={50}
                rowCount={paginantion.totalRowCount}
                pageIndex={paginantion.pageIndex}
                pageChange={(index) => {
                    setPaginantion((prev) => {
                        prev.pageIndex = index;
                    });
                }}
                pageSize={paginantion.pageSize}
                pageSizeChange={(size) => {
                    setPaginantion((prev) => {
                        prev.pageSize = size;
                    });
                }}
            />
        </div>
    );
};

export default MaintenanceDataTable;